<template>
  <div class="massage-record">
    <div class="record-header">
      <div class="title-wrapper">
        <div class="title-bar" />
        <h3 class="title">按摩记录</h3>
      </div>
      <div class="time-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="['tab-btn', { active: activeTab === tab.value }]"
          @click="handleTabChange(tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>
    </div>

    <div class="record-content">
      <!-- 左侧统计 -->
      <div class="left-stats">
        <div class="massage-icon">
          <div class="icon-circle">
            <img src="@/assets/icon/anmo.png" style="width: 60px;" alt="">
          </div>
        </div>
        <div class="stat-number">
          <span class="number">{{ totalCount }}</span>
          <span class="unit">次</span>
        </div>
        <div class="stat-label">按摩</div>
      </div>

      <!-- 右侧穴位列表 -->
      <div class="acupoint-list">
        <div
          v-for="(acupoint, index) in displayList"
          :key="index"
          class="acupoint-item"
        >
          <div class="acupoint-image">
            <img v-if="acupoint.image" :src="acupoint.image" :alt="acupoint.name">
            <img v-else src="@/assets/icon/zanwu.png" alt="">
            <div v-if="acupoint.label" class="image-label">{{ acupoint.label }}</div>
          </div>
          <div class="acupoint-count">
            <span class="count">{{ acupoint.count }}</span>
            <span class="count-unit">次</span>
          </div>
          <div class="acupoint-name">{{ acupoint.name }}</div>
        </div>
        <div v-if="displayList.length === 0" class="empty-text">
          暂无记录
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MassageRecord',
  props: {
    acupointList: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: String,
      default: '3' // 改为 '3'
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabs: [
        { label: '日', value: '1' }, // 改为 '1'
        { label: '周', value: '2' }, // 改为 '2'
        { label: '月', value: '3' } // 改为 '3'
      ]
    }
  },
  computed: {
    displayList() {
      return this.acupointList.length > 0 ? this.acupointList : [
      ]
    }
  },
  methods: {
    handleTabChange(value) {
      // 直接 emit 数字
      this.$emit('tab-change', value)
    }
  }
}
</script>

<style scoped>
.massage-record {
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-bar {
  width: 4px;
  height: 18px;
  background: #333;
  border-radius: 2px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.time-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  padding: 4px 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
}

.tab-btn:hover {
  border-color: #4a7dff;
  color: #4a7dff;
}

.tab-btn.active {
  background: #4a7dff;
  border-color: #4a7dff;
  color: #fff;
}

.record-content {
  display: flex;
  gap: 30px;
}

.left-stats {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  padding-top: 10px;
}

.massage-icon {
  margin-bottom: 12px;
}

.icon-circle {
  width: 60px;
  height: 60px;
  background: #fff7e6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ff9f43;
}

.icon-circle svg {
  width: 32px;
  height: 32px;
}

.stat-number {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.number {
  font-size: 32px;
  font-weight: 700;
  color: #333;
}

.unit {
  font-size: 14px;
  color: #666;
}

.stat-label {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.acupoint-list {
  flex: 1;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.acupoint-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.acupoint-image {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.acupoint-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-label {
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 10px;
  color: #333;
  line-height: 1.3;
  text-align: center;
  white-space: pre-line;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.acupoint-count {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.count {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.count-unit {
  font-size: 12px;
  color: #666;
}

.acupoint-name {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.empty-text {
  flex: 1;
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 40px 0;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  margin-top: 20px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4a7dff, #6b9fff);
  border-radius: 3px;
  transition: width 0.3s ease;
}
</style>
